import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5252cae1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "custom-date-popup shadow-lg"
}
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "From Date", -1))
const _hoisted_6 = ["value", "max"]
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "To Date", -1))
const _hoisted_9 = ["value", "min", "max"]
const _hoisted_10 = { class: "d-flex gap-2" }
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("input", {
              type: "date",
              class: "form-control",
              value: _ctx.dateFrom,
              onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDateFromInput && _ctx.handleDateFromInput(...args))),
              max: _ctx.dateTo || _ctx.maxDate
            }, null, 40, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("input", {
              type: "date",
              class: "form-control",
              value: _ctx.dateTo,
              onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleDateToInput && _ctx.handleDateToInput(...args))),
              min: _ctx.dateFrom,
              max: _ctx.maxDate
            }, null, 40, _hoisted_9)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "btn btn-secondary btn-sm flex-fill",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancel')))
            }, " Cancel "),
            _createElementVNode("button", {
              class: "btn btn-primary btn-sm flex-fill",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleApply && _ctx.handleApply(...args))),
              disabled: !_ctx.dateFrom || !_ctx.dateTo
            }, " Apply ", 8, _hoisted_11)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}